import { Badge, Progress } from 'antd';
import React from 'react';
import { getColorByScore } from '../utils';
import { ScoreData } from '../types';

type Props = {
    url: string;
    scoreData: ScoreData;
};

export default function CompetitorSeoScore({ url, scoreData }: Props) {
    return (
        <div className="competitor-item">
            <div className="summary-graph">
                <div className="summary-graph-total">
                    <Progress
                        type="circle"
                        percent={scoreData.score}
                        strokeWidth={8}
                        strokeColor={getColorByScore(scoreData.score)}
                        format={(percent) => `${percent}/100`}
                        data-cy="competitor-score"
                    />
                </div>
            </div>
            <div className="meta-info">
                <div className="url">{url}</div>
                <div>
                    <span>
                        {scoreData.failed} <Badge status="error" />
                    </span>
                    <span>
                        {' '}
                        {scoreData.warning} <Badge status="warning" />
                    </span>
                    <span>
                        {' '}
                        {scoreData.passed} <Badge status="success" />
                    </span>
                </div>
            </div>
        </div>
    );
}
